export default __webpack_public_path__ + "static/media/loginimage.dd249625.jpg";